import { render } from "./resetLO.vue?vue&type=template&id=68aa5010"
import script from "./resetLO.vue?vue&type=script&lang=js"
export * from "./resetLO.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__